<template>
  <div>
    <MglMarker
      v-for="port in nearestPorts"
      :key="port.code"
      :coordinates="[port.lon, port.lat]"
    >
      <div slot="marker" class="port-marker">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div class="port-marker-container" v-bind="attrs" v-on="on">
              <div class="port-marker-icon">
                <v-icon size="16" color="white">mdi-anchor</v-icon>
              </div>
            </div>
          </template>
          <span class="port-tooltip">{{ port.name }}</span>
        </v-tooltip>
      </div>
    </MglMarker>

    <MglMarker
      :coordinates="[
        currentVesselCoordinates.Longitude,
        currentVesselCoordinates.Latitude,
      ]"
    >
      <div slot="marker" class="vessel-marker">
        <div class="vessel-marker-container">
          <div class="vessel-marker-icon">
            <v-icon size="18" color="white">mdi-ferry</v-icon>
          </div>
        </div>
      </div>
    </MglMarker>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { MglMarker } from "vue-mapbox";

export default {
  name: "PortLocationMarkers",
  components: {
    MglMarker,
  },
  computed: {
    ...mapState("weatherRouting", ["currentVesselCoordinates"]),
    ...mapState("weatherRouting/portModule", ["nearestPorts"]),
  },
};
</script>

<style scoped>
.port-marker-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.port-marker-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: 2px solid white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 2;
  position: relative;
}

.vessel-marker {
  position: relative;
}

.vessel-marker-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vessel-marker-icon {
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);
  border: 2px solid white;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 2;
  position: relative;
}

.port-tooltip {
  font-weight: 500;
  font-size: 14px;
  color: var(--color-text);
}
</style>